import { LogOut, Key } from 'lucide-react';
import { useAuthStore } from '@/stores/authStore';
import { useNavigate } from 'react-router-dom';

export default function Header() {
  const apiKey = useAuthStore((state) => state.apiKey);
  const clearApiKey = useAuthStore((state) => state.clearApiKey);
  const navigate = useNavigate();

  const handleLogout = () => {
    clearApiKey();
    navigate('/login');
  };

  const maskedKey = apiKey
    ? apiKey.length >= 12
      ? `${apiKey.substring(0, 8)}...${apiKey.substring(apiKey.length - 4)}`
      : `${apiKey.substring(0, Math.min(4, apiKey.length))}...`
    : '';

  return (
    <header className="border-b border-border bg-card/50 backdrop-blur sticky top-0 z-50">
      <div className="px-8 py-4 flex items-center justify-between">
        {/* Logo and Title */}
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-gradient-to-br from-primary to-chart-2">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              className="w-6 h-6"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <defs>
                <linearGradient id="header-logo-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="currentColor" className="text-white" />
                  <stop offset="100%" stopColor="currentColor" className="text-white/80" />
                </linearGradient>
              </defs>
              <rect x="3" y="5" width="18" height="1.5" rx="0.75" fill="url(#header-logo-gradient)" opacity="0.5" />
              <rect x="3" y="11" width="18" height="1.5" rx="0.75" fill="url(#header-logo-gradient)" />
              <rect x="3" y="17" width="18" height="1.5" rx="0.75" fill="url(#header-logo-gradient)" opacity="0.5" />
            </svg>
          </div>
          <div>
            <h1 className="text-lg font-bold bg-gradient-to-r from-primary to-chart-2 bg-clip-text text-transparent">
              BetterInfra Dashboard
            </h1>
            <p className="text-xs text-muted-foreground">Jobs API Monitor</p>
          </div>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-3">
          {/* API Key Display */}
          <div className="flex items-center gap-2 px-3 py-1.5 rounded-md bg-muted/50 border border-border">
            <Key className="h-4 w-4 text-muted-foreground" />
            <code className="text-xs font-mono">{maskedKey}</code>
          </div>

          {/* Logout Button */}
          <button
            type="button"
            onClick={handleLogout}
            className="flex items-center gap-2 px-3 py-1.5 rounded-md bg-destructive/10 hover:bg-destructive/20 text-destructive border border-destructive/30 transition-colors"
            title="Logout"
          >
            <LogOut className="h-4 w-4" />
            <span className="text-sm font-medium">Logout</span>
          </button>
        </div>
      </div>
    </header>
  );
}
